import { useQuery } from "@tanstack/react-query";
import { isMock, getJson } from "./client";

export interface ModelRegistryEntry {
  modelId: number;
  modelName: string;
  modelVersion: string | null;
  productType: string | null;
  modelTier: number | null;
}

export function modelLabel(m: ModelRegistryEntry): string {
  return m.modelVersion ? `${m.modelName} v${m.modelVersion}` : m.modelName;
}

const MOCK_REGISTRY: ModelRegistryEntry[] = [
  { modelId: 1, modelName: "Champion",   modelVersion: "1.2", productType: "PG",   modelTier: 1 },
  { modelId: 2, modelName: "Challenger", modelVersion: "1.3", productType: "PG",   modelTier: 2 },
  { modelId: 3, modelName: "Challenger", modelVersion: "1.3", productType: "CORP", modelTier: 2 },
];

export async function fetchModelRegistry(): Promise<ModelRegistryEntry[]> {
  if (isMock) return Promise.resolve(MOCK_REGISTRY);
  return getJson<ModelRegistryEntry[]>("model-drift-monitoring/model-registry");
}

export function useModelRegistry() {
  return useQuery({
    queryKey: ["model-registry"],
    queryFn: fetchModelRegistry,
  });
}
